'use strict';

/**
 *  manuscriptPreviewModule 电视渠道广电广电文稿详情页
 *  Author Qian.qianchen 2019-04-18
 *  Description
 */
angular.module('manuscriptPreviewModule', [
    'trsPreviewHeightModule',
    'trsPreviewContentModule'
])
    .controller('manuscriptPreviewCtrl', ['$scope', 'initeditctrBtnsService', '$stateParams', '$q', 'trsHttpService', 'modalDialog', 'localStorageService', '$state', '$window', 'trsPrintService', 'editIsLock', 'editcenterRightsService', 'editingCenterService',
        function ($scope, initeditctrBtnsService, $stateParams, $q, trsHttpService, modalDialog, localStorageService, $state, $window, trsPrintService, editIsLock, editcenterRightsService, editingCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    fromsearch: $stateParams.fromsearch,
                    listOpen: 1,
                    btnRights: {},
                    previewBigFace: {
                        status: false
                    },
                    isfromplannedorder: !!((!!$stateParams.isfromplannedorder && $stateParams.isfromplannedorder == 'true')),
                };
                $scope.data = {
                    userData: [],
                    reporterStr: [],
                    broadcastStr: [],
                    editorStr: [],
                    printResult: [],
                };
                initBtnRights();
            }

            /**
             * [initBtnRights description] 初始化按钮权限
             * @return {[type]} [description]
             */
            function initBtnRights() {
                let rightsMethod = ['tv.daibian', 'tv.daishen', 'tv.yiqianfa'];
                initeditctrBtnsService.initTvData($stateParams.tvchannelid, rightsMethod[$stateParams.tvplatform]).then((data) => {
                    // if ($scope.status.isfromplannedorder) {
                    //     return;
                    // } else {
                    data.forEach((item, index) => {
                        $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                    });
                    // }
                });
                // 获取查看痕迹按钮权限
                editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                    $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                });

                /* initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                    data.forEach((item, index) => {
                        $scope.status.btnRights[item.OPERNAME.split(".")[2]] = true;
                    });
                });*/
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
            }

            /**
             * [requestData description] 获取广电广电文稿数据
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_tv',
                    methodname: 'getWenGaoDoc',
                    MetaDataId: $stateParams.tvmetadataid,
                    fromsearch: $stateParams.fromsearch
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    data.EXATTRIBUTE = data.EXATTRIBUTE instanceof Array ? data.EXATTRIBUTE : [];
                    $scope.data.manuscriptDetail = data;
                    $scope.data.broadcastStr = data.BROADCASTING.map(function (item) {
                        return item.USERNAME;
                    }).join('、');
                    $scope.data.reporterStr = data.FGD_AUTHINFO.map(function (item) {
                        return item.USERNAME;
                    }).join('、');
                    $scope.data.compileStr = data.FGD_EDITINFO.map(function (item) {
                        return item.USERNAME;
                    }).join('、');
                    document.title = data.TITLE;
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getObjFromArr description] 根据属性查询数组中的对象
             * @param  {[type]} arr      [description] 数组
             * @param  {[type]} property [description] 属性名
             * @param  {[type]} value    [description] 属性只
             * @return {[type]}          [description]
             */
            function getObjFromArr(arr, property, value) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][property] == value) {
                        return arr[i];
                    }
                }
                return -1;
            }

            /**
             * [pageTurning description] 翻页 上一篇/下一篇
             * @param {int} direction [description]
             * @return {[type]} [description]
             */
            $scope.pageTurning = function (direction) { // 88
                var pageTurningData;
                pageTurningData = JSON.parse(localStorageService.get('televisionPreview'));
                var metadataid = $stateParams.tvmetadataid;
                var toPageData;
                for (var i = 0; i < pageTurningData.length; i++) {
                    if (pageTurningData[i].METADATAID === metadataid ||
                        pageTurningData[i].DOCID === metadataid ||
                        pageTurningData[i].MLFID === metadataid) {
                        toPageData = pageTurningData[i + direction];
                        break;
                    }
                }
                if (!toPageData) {
                    var directionTxt = direction === 1 ? '下' : '上';
                    modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                    return;
                }
                $state.go($state.current.name, {
                    tvchnldocid: toPageData.CHNLDOCID,
                    tvchannelid: toPageData.CHANNELID,
                    tvmetadataid: toPageData.METADATAID,
                    tvtypeid: toPageData.DOCTYPEID,
                    tvsiteid: $stateParams.tvsiteid,
                    tvplatform: $stateParams.tvplatform
                }, {
                    reload: true
                });
            };

            /**
             * [creationAxis description] 添加到个人素材
             * @return {[type]} [description]
             */
            $scope.creationAxis = function () {
                var params = {
                    serviceid: 'mlf_releasesource',
                    methodname: 'addPersonalMaterialOfTxt',
                    PersonalMaterialId: 0,
                    metadataid: $stateParams.tvmetadataid,
                    MediaType: '-1'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('添加成功', '', 'success', false);
                    $window.document.getSelection().collapse($window.document, 1);
                });
            };

            /**
             * [edit description] 广电广电文稿编辑
             * @return {[type]} [description]
             */
            $scope.edit = function () {
                var routerParams;
                editIsLock.isLock($scope.data.manuscriptDetail, 15).then(function (data) {
                    routerParams = {
                        tvplatform: $stateParams.tvplatform,
                        tvmetadataid: $stateParams.tvmetadataid,
                        tvchnldocid: $stateParams.tvchnldocid,
                        tvsiteid: $stateParams.tvsiteid,
                        tvchannelid: $stateParams.tvchannelid
                    };
                    if (data.ISLOCK == 'false') {
                        $state.go('televisionmanuscript', routerParams);
                    } else {
                        editIsLock.checkUnlockPermissions($scope.data.manuscriptDetail, data).then(function () {
                            $state.go('televisionmanuscript', routerParams);
                        });
                    }
                });
            };

            /**
             * [printBtn 打印]
             * @return {[type]} [description]
             */
            $scope.printBtn = function () {
                $scope.status.isESSearch = false;
                // if (checkDraftType($scope.status.draftType.subject)) {
                //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
                //     return;
                // }
                // angular.forEach($scope.data.selectedArray, function(value, key) {
                requestPrintData();
                // });
            };

            /**
             * [requestPrintData 打印请求详情]
             * @param  {[type]} item    [description]
             * @param  {[type]} version [description]
             * @return {[type]}         [description]
             */
            function requestPrintData(item) {
                var params;
                params = {
                    'serviceid': 'mlf_tv',
                    'methodname': 'getWenGaoDoc',
                    'MetaDataId': $stateParams.tvmetadataid
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var result = data;
                    // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    // if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                    trsPrintService.trsTvPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                    // }
                });
            }

            /**
             * [bigFace description] 查看痕迹
             * @return {[type]} [description]
             */
            $scope.bigFace = function () {
                $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
            };

            /**
             * [goToEdit description]
             *
             * @return  {[type]}  [return description]
             */
            $scope.goToEdit = function() {
                var extraParams = {
                    tvchnldocid: $state.params.tvchnldocid,
                    tvsiteid: $state.params.tvsiteid,
                    tvplatform: $state.params.tvplatform,
                    mediaType: '15'
                };
                editingCenterService.routerToEditorWithLock(angular.extend($scope.data.manuscriptDetail, extraParams));
            };
        }
    ]);
